import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { TRANSLATE_HTTP_LOADER_CONFIG } from '@ngx-translate/http-loader';


if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic([
  {
    provide: TRANSLATE_HTTP_LOADER_CONFIG,
    useValue: { prefix: './assets/i18n/', suffix: '.json' }
  }
]).bootstrapModule(AppModule)
  .catch(err => console.error(err));

/*if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));*/
